export default {
  items: [
    {
      name: '메인화면',
      url: '/dashboard',
      icon: 'fa fa-desktop fa-lg',
      customId: 'mainCustomId8642'
    },
    {
      title: true,
      name: 'Estimation',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: '리치 시뮬레이션(DA)',
      url: '/reach/da/reach?status=new',
      icon: 'fa fa-image fa-lg',
      customId: 'reachDACustomId8642'
    },
    {
      name: '리치 시뮬레이션(VA)',
      url: '/reach/reach?status=new',
      icon: 'fa fa-video-camera fa-lg',
      customId: 'reachCustomId8642'
    },
    {
      name: '예산안 최적화',
      url: '/budget/budget?status=new',
      icon: 'fa fa-money fa-lg',
      customId: 'budgetCustomId8642'
    },
    // {
    //   name: '업종별 미디어 효과 비교',
    //   url: '/compare/compare',
    //   icon: 'fa fa-balance-scale fa-lg'
    // },
    {
      name: '리치 커브 시뮬레이션',
      url: '/curve/curve?status=new',
      icon: 'fa fa-line-chart fa-lg',
      customId: 'reachCurveCustomId8642'
    },
    {
      title: true,
      name: 'SYSTEM',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: '모델 커스터마이징',
      url: '/model/customizing',
      icon: 'fa fa-cogs fa-lg',
      customId: 'modelCustomId8642'

    },
    {
      name: '시스템/데이터 안내',
      url: '/help/systeminfo',
      icon: 'fa fa-info fa-lg',
      customId: 'systemInfoCustomId8642'

    },
    // {
    //   title: true,
    //   name: 'Management',
    //   class: '',
    //   wrapper: {
    //     element: '',
    //     attributes: {}
    //   }
    // },
    // {
    //   name: '데이터 관리',
    //   url: '/data',
    //   icon: 'icon-settings',
    //   children: [
    //     {
    //       name: '계수',
    //       url: '/data/coefficient',
    //       icon: 'icon-calculator'
    //     },
    //     {
    //       name: '닐슨',
    //       url: '/data/nielsendata',
    //       icon: 'fa fa-cubes fa-lg'
    //     },
    //     {
    //       name: 'DMC',
    //       url: '/data/dmcdata',
    //       icon: 'fa fa-database fa-lg'
    //     }
    //   ]
    // },
    // {
    //   name: '게시판 관리',
    //   url: '/board',
    //   icon: 'icon-settings',
    //   children: [
    //     {
    //       name: '공지사항',
    //       url: '/board/notice',
    //       icon: 'icon-calculator'
    //     },
    //     {
    //       name: 'F&Q',
    //       url: '/board/qa',
    //       icon: 'fa fa-cubes fa-lg'
    //     },
    //     {
    //       name: '문의사항',
    //       url: '/board/qa',
    //       icon: 'fa fa-cubes fa-lg'
    //     }
    //   ]
    // },
    // {
    //   name: '사용자 관리',
    //   url: '/user/user',
    //   icon: 'icon-people'
    // },
    {
      divider: true
    },
    // {
    //   name: 'DMC MEDIA',
    //   url: 'http://www.dmcmedia.co.kr/',
    //   icon: 'fa fa-star fa-lg',
    //   class: 'mt-auto',
    //   variant: 'gray-600'
    // },
    // {
    //   name: 'F-1',
    //   url: 'http://f1dmc.com/',
    //   icon: 'fa fa-facebook fa-lg',
    //   variant: 'gray-700'
    // },
    // {
    //   name: 'ADPOOL',
    //   url: 'http://www.adpool.co.kr/',
    //   icon: 'fa fa-cloud fa-lg',
    //   variant: 'gray-600'
    // },
    // {
    //   name: 'DMC REPORT PRO',
    //   url: 'https://pro.dmcreport.co.kr/main',
    //   icon: 'icon-docs',
    //   variant: 'gray-700'
    // },
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js